module.exports = __webpack_public_path__ + "img/na'na'.588e32c2.jpeg";